const testimonials = [
  {
    name: "Rachel K.",
    location: "Fargo, ND",
    rating: 5,
    text: "I got my passport in 6 days from Fargo. I was honestly skeptical that it could work without me driving to Chicago, but Fast Passport Center made it completely seamless. Highly recommend for anyone in North Dakota.",
    trip: "Traveling to Iceland",
  },
  {
    name: "Michael T.",
    location: "West Fargo, ND",
    rating: 5,
    text: "My wife and I both needed renewals before our European river cruise. Fast Passport Center handled both in one week. The daily updates were so reassuring — we never had to wonder what was happening.",
    trip: "Rhine River Cruise",
  },
  {
    name: "Samantha J.",
    location: "Moorhead, MN",
    rating: 5,
    text: "Living on the Minnesota side of Fargo, I wasn't sure if they could help me. They absolutely could. My passport arrived in 8 days. The agent caught a photo issue before it caused a rejection. Worth every penny.",
    trip: "Cancún family vacation",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Customer Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Fargo Travelers Say About Us
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Real reviews from Fargo and Red River Valley passport customers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-7 flex flex-col">
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-200">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]">
                  <i className="ri-user-line text-[#1A365D]"></i>
                </div>
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location} &middot; {t.trip}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}